module.exports = {"330213001":"锦屏街道","330213002":"岳林街道","330213003":"江口街道","330213004":"西坞街道","330213005":"萧王庙街道","330213100":"溪口镇","330213103":"尚田镇","330213104":"莼湖镇","330213106":"裘村镇","330213107":"大堰镇","330213108":"松岙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330213.json
// module id = 961
// module chunks = 0